import { __rest } from "tslib";
import React from 'react';
import { default as getVariationsFromProps } from "@pb/utils/common/getVariationsFromProps";
import cn from 'classnames';
import styles from './Heading.module.scss';
const Heading = (_a) => {
    var { Tag = 'h1', className, children, horizontalAlignment, lineClamp } = _a, props = __rest(_a, ["Tag", "className", "children", "horizontalAlignment", "lineClamp"]);
    const [variationsClassNames, passableProps] = getVariationsFromProps(Object.assign(Object.assign({}, props), (!!lineClamp && { [`lineClamp${lineClamp}`]: true })), styles);
    return (React.createElement(Tag, Object.assign({ className: cn(styles.general, className, variationsClassNames, horizontalAlignment ? styles[horizontalAlignment] : undefined) }, passableProps), children));
};
export default Heading;
//# sourceMappingURL=Heading.js.map